// Message Input Component

import React from 'react';
import { Send } from 'lucide-react';
import { COLORS } from '../../constants/theme';

const MessageInput = ({
  inputValue,
  onInputChange,
  onSend,
  disabled,
  isEditing = false,
  onCancelEdit,
}) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (!disabled) onSend();
    }
  };

  return (
    <div className="bg-white/95 backdrop-blur border-t border-gray-200 animate-fade-in-up">
      <div className="max-w-5xl mx-auto px-3 sm:px-4 md:px-6 py-3 md:py-4">
        {isEditing && (
          <div className="mb-2 flex items-center justify-between bg-amber-50 border border-amber-200 rounded-lg px-3 py-2">
            <p className="text-xs text-amber-800 font-medium">Editing an earlier prompt</p>
            <button
              onClick={onCancelEdit}
              className="text-xs text-amber-800 hover:underline"
            >
              Cancel
            </button>
          </div>
        )}
        <div className="flex items-center gap-2 sm:gap-3">
          <div className="flex-1 min-w-0">
            <textarea
              value={inputValue}
              onChange={(e) => onInputChange(e.target.value)}
              onKeyDown={handleKeyDown}
            aria-label="Ask a question about your data"
              placeholder="Ask a question about your data..."
              className="w-full px-4 sm:px-5 py-3.5 sm:py-4 bg-white border border-gray-300 rounded-xl resize-none focus:outline-none focus:ring-2 focus:ring-pink-200 focus:border-pink-500 text-sm transition-all duration-200"
              style={{ minHeight: '56px', maxHeight: '120px', boxShadow: '0 1px 2px rgba(0,0,0,0.04)' }}
              rows="1"
            />
          </div>
          <button
            onClick={onSend}
            disabled={disabled}
            aria-label={isEditing ? 'Update prompt' : 'Send message'}
            className="px-3.5 sm:px-5 py-3.5 text-white rounded-xl font-medium transition-all duration-300 disabled:opacity-50 flex items-center gap-1.5 sm:gap-2 hover:shadow-lg disabled:hover:shadow-none"
            style={{ backgroundColor: COLORS.primary }}
          >
            <Send className="w-5 h-5" />
            <span className="hidden sm:inline">{isEditing ? 'Update' : 'Send'}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default MessageInput;

